import { GraphqlChannel } from '@/features/graphql/constants'
import { HttpLink } from '@apollo/client'

export const httpLink = (uri: string, language: string, channel: GraphqlChannel) =>
    new HttpLink({
        uri,
        headers: {
            'X-Channel': channel,
            'X-Language': language,
        },
    })
